import React,{useEffect,useState} from 'react';
import axios from 'axios'

export default function Donet12() {

//   const [loading, setLoading] = useState(false);
//   const [orderAmount, setOrderAmount] = useState(0);
//   const [orders, setOrders] = useState([]);

//   async function fetchOrders() {
//     const { data } = await axios.get('/list-orders');
//     setOrders(data);
//   }
//   useEffect(() => {
//     fetchOrders();
//   }, []);

//   function loadRazorpay() {
//     const script = document.createElement('script');
//     script.src = 'https://checkout.razorpay.com/v1/checkout.js';
//     script.onerror = () => {
//       alert('Razorpay SDK failed to load. Are you online?');
//     };
//     script.onload = async () => {
//       try {
//         setLoading(true);
//         const result = await axios.post('/create-order', {
//           amount: orderAmount + '00',
//         });
//         const { amount, id: order_id, currency } = result.data;
//         const {
//           data: { key: razorpayKey },
//         } = await axios.get('/get-razorpay-key');

//         const options = {
//           key: razorpayKey,
//           amount: amount.toString(),
//           currency: currency,
//           name: 'example name',
//           description: 'example transaction',
//           order_id: order_id,
//           handler: async function (response) {
//             const result = await axios.post('/pay-order', {
//               amount: amount,
//               razorpayPaymentId: response.razorpay_payment_id,
//               razorpayOrderId: response.razorpay_order_id,
//               razorpaySignature: response.razorpay_signature,
//             });
//             alert(result.data.msg);
//             fetchOrders();
//           },
//           prefill: {
//             name: 'example name',
//             email: 'email@example.com',
//             contact: '111111',
//           },
//           notes: {
//             address: 'example address',
//           },
//           theme: {
//             color: '#80c0f0',
//           },
//         };

//         setLoading(false);
//         const paymentObject = new window.Razorpay(options);
//         paymentObject.open();
//       } catch (err) {
//         alert(err);
//         setLoading(false);
//       }
//     };
//     document.body.appendChild(script);
//   }

//   return (
//     <section id="breadcrumbs" class="breadcrumbs1">
//      <section id="contact" class="contact1">
//     <div className="App">
//       <h1> Razorpay Example: Node & React</h1>
//       <hr />
//       <div>
//         <h2> Pay Order</h2>
//         <label>
//           Amount:{' '}
//           <input
//             placeholder="INR"
//             type="number"
//             value={orderAmount}
//             onChange={(e) => setOrderAmount(e.target.value)}
//           ></input>
//         </label>

//         <button disabled={loading} onClick={loadRazorpay}>
//           Razorpay
//         </button>
//         {loading && <div>Loading...</div>}
//       </div>
//       <div className="list-orders">
//         <h2>List Orders</h2>
//         <table>
//           <thead>
//             <tr>
//               <th>ID</th>
//               <th>AMOUNT</th>
//               <th>ISPAID</th>
//               <th>RAZORPAY</th>
//             </tr>
//           </thead>
//           <tbody>
//             {orders.map((x) => (
//               <tr key={x._id}>
//                 <td>{x._id}</td>
//                 <td>{x.amount / 100}</td>
//                 <td>{x.isPaid ? 'YES' : 'NO'}</td>
//                 <td>{x.razorpay.paymentId}</td>
//               </tr>
//             ))}
//           </tbody>
//         </table>
//       </div>
//     </div>
//     </section>
//     </section>
//   );


   return (
     <section id="breadcrumbs" class="breadcrumbs1">

   
<section id="contact" class="contact1">
 <div class="container">
<h1> Under construction  </h1>
 </div>

</section>
 </section>
   )
}


// import React,{useState} from 'react';
// export default function Donet() {
// const [amount,setamount]=useState('');
// const [name, setName] = useState('');
// const [email, setEmail] = useState('');
// const [mobile, setMobile] = useState('');
// const [message, setMessage] = useState('');
// const [formErrors, setFormErrors] = useState({});
// const [bolt,setBolt]=useState('')
// const [num, setNum] = useState(0);


// function randomNumberInRange(min, max) {
//     // 👇️ get number between min (inclusive) and max (inclusive)
//     return Math.floor(Math.random() * (max - min + 1)) + min;
//   }

//   const handleClick = () => {
//     setNum(randomNumberInRange(10000,99999999));
//   };


// const validate = () => {
//     const errors = {};
//     if (!amount) {
//         errors.amount = "Please Enter Name";
//       }
//       if (!name) {
        
//         errors.name = "Please Enter Image";
//                 }
//       if (!email) {
//         errors.email = "Please Enter Description";
//       }
//       if (!mobile) {
//         errors.mobile = "Please Enter your status";
//       }

//     // var txnid = document.payment_form.txnid.value;
// 	// 	var amount=document.payment_form.amount.value;
// 	// 	var fname=document.payment_form.fname.value;				
// 	// 	var email=document.payment_form.email.value;
// 	// 	var mobile = document.payment_form.mobile.value;
		
// 	// 	var e = document.getElementById("pinfo");
// 	// 	var pinfo1 = e.options[e.selectedIndex].value;
		
// 	// 	if(txnid.length=="" || txnid.match(/^ *$/) !== null)
// 	// 	{
// 	// 	    alert("Something Is Wrong Please Try Again");  
//     //         return false;  
// 	// 	}
// 	// 	else if(amount.length=="" || amount.match(/^ *$/) !== null) 
// 	// 	{
//     //         alert("Please Enter Amount..");  
//     //         return false;  
//     //     }
//     //     else if(pinfo1=="0")
//     //     {
//     //         alert("Please Select Product Name..");  
//     //         return false;  
//     //     }
//     //     else if(fname.length=="" || fname.match(/^ *$/) !== null)
//     //     {
//     //         alert("Please Enter Name..");  
//     //         return false;  
//     //     }
//     //     else if(email.length=="" || email.match(/^ *$/) !== null)
//     //     {
//     //         alert("Please Enter Email Id..");  
//     //         return false;  
//     //     }
//     //     else if(mobile.length=="" || mobile.match(/^ *$/) !== null)
//     //     {
//     //         alert("Please Enter Mobile/Cell Number..");  
//     //         return false;  
//     //     }
//         // else
//         // { 
//         //    launchBOLT(); return false;
//         // }
		
    
//     return errors;
//   };
// //   function launchBOLT()
  
// // {
// // 	bolt.launch({
// // 	key: ('#key').val(),
// // 	txnid: ('#txnid').val(), 
// // 	hash: ('#hash').val(),
// // 	amount: ('#amount').val(),
// // 	firstname: ('#fname').val(),
// // 	email: ('#email').val(),
// // 	phone: ('#mobile').val(),
// // 	productinfo: ('#pinfo').val(),
// // 	udf5: ('#udf5').val(),
// // 	surl : ('#surl').val(),
// // 	furl: ('#surl').val(),
// // 	mode: 'dropout'	
// // },{ responseHandler: function(BOLT){
// // 	console.log( BOLT.response.txnStatus );		
// // 	if(BOLT.response.txnStatus != 'CANCEL')
// // 	{
// // 		//Salt is passd here for demo purpose only. For practical use keep salt at server side only.
// // 		var fr = '<form action=\"'+('#surl').val()+'\" method=\"post\">' +
// // 		'<input type=\"hidden\" name=\"key\" value=\"'+BOLT.response.key+'\" />' +
// // 		'<input type=\"hidden\" name=\"salt\" value=\"'+('#salt').val()+'\" />' +
// // 		'<input type=\"hidden\" name=\"txnid\" value=\"'+BOLT.response.txnid+'\" />' +
// // 		'<input type=\"hidden\" name=\"amount\" value=\"'+BOLT.response.amount+'\" />' +
// // 		'<input type=\"hidden\" name=\"productinfo\" value=\"'+BOLT.response.productinfo+'\" />' +
// // 		'<input type=\"hidden\" name=\"firstname\" value=\"'+BOLT.response.firstname+'\" />' +
// // 		'<input type=\"hidden\" name=\"email\" value=\"'+BOLT.response.email+'\" />' +
// // 		'<input type=\"hidden\" name=\"udf5\" value=\"'+BOLT.response.udf5+'\" />' +
// // 		'<input type=\"hidden\" name=\"mihpayid\" value=\"'+BOLT.response.mihpayid+'\" />' +
// // 		'<input type=\"hidden\" name=\"status\" value=\"'+BOLT.response.status+'\" />' +
// // 		'<input type=\"hidden\" name=\"hash\" value=\"'+BOLT.response.hash+'\" />' +
// // 		'</form>';
// // 		// var form = jQuery(fr);
// // 		// jQuery('body').append(form);								
// // 		// form.submit();
// // 	}
// // },
// // 	catchException: function(BOLT){
// //  		alert( BOLT.message );
// // 	}
// // });
// // }

// // const submitHandle = async (e) => {
// //   e.preventDefault()
// // if (amount==="")
// // {
// //   alert("enter amount")
// // }else{
// //   var options={
// //     key:"",
// //     key_secret:"",
// //     amount:amount*100,
// //     currency:"INR",
// //     name :"startup_Projects",
// //     description: 'example transaction',
// //     handler:function(response){
// //       alert(response.razorpay_payment_id);
// //     },
// //     prefill:{
// //       name: 'example name',
// //       email: 'email@example.com',
// //       contact: '111111'
// //     },
// //     notes: {
// //       address: 'Razorpay crporate office',
// //     },
// //     theme: {
// //       color: '#80c0f0',
// //     },
// //   };
// //   var pay=new window.Razorpay(options);
// //   pay.open();
// // }
// // }
// return (
// //   // <section id="breadcrumbs" class="breadcrumbs1">
// //   //  <section id="contact" class="contact1">
// //   // <div className="App">
// //   //   <h1> Razorpay Example: Node & React</h1>
// //   //   <hr />
// //   //   <div>
// //   //     <h2> Pay Order</h2>
// //   //     <label>
// //   //       Amount:{' '}
// //   //       <input
// //   //         placeholder="INR"
// //   //         type="number"
// //   //         value={amount}
// //   //         onChange={(e) => setamount(e.target.value)}
// //   //       ></input>
// //   //     </label>
// //   //     <button onClick={submitHandle}>submit</button>
// //   //     {/* <button>
// //   //       <a href="payment" rel="dns-prefetch">
// //   //         <i class="fa fa-paypal text-center"></i></a>
// //   //       </button> */}
// //   //       <a href="https://www.payumoney.com/paybypayumoney/#/258963" target="_blank" rel="noreferrer" class="highlight-button-dark btn btn-small button xs-margin-bottom-five">Click Here</a>
// //   //     </div>
      
// //   //     </div></section></section>
//   <section id="breadcrumbs" class="breadcrumbs1">
//   <section id="contact" class="contact1">
//   <div class="container">
//    <div class="row">
//       <div class="col-md-6 col-sm-6">
//          <h2 class="black-text text-center center-col pro">PAYU PAYMENT GATEWAY</h2>
//          <center class="pdtp"><a href="https://www.payumoney.com/paybypayumoney" target="_blank" rel="noreferrer"><img src="/assets/img/slide/PayU-logo.jpg" alt="PayU Money"/></a><br></br>
        
//           <a href="https://www.payumoney.com/paybypayumoney/#/258963" target="_blank" rel="noreferrer" class="highlight-button-dark btn btn-small button xs-margin-bottom-five">Click Here</a></center>
        
//       </div>
//       {/* <button> Click me </button> */}
//       {/* <div class="col-md-6 col-sm-6">
//          <h2 class="black-text text-center center-col pro">QR Code</h2>
//          <center class="pdtp"><img src="images/qrcode-scan.jpg" alt="QR Code"/><br></br></center>
//       </div> */}
//       <form>
//                 <div class="dv"  style={{display:"none"}}>
//                     <span class="text12"><label>Merchant Key:</label></span>
//                     <span><input type="text" id="key" name="key" placeholder="Merchant Key" value="p8SKrfEh" /></span>
//                 </div>
//                 <div class="dv"  style={{display:"none"}} >
//                     <span class="text12"><label>Merchant Salt:</label></span>
//                     <span><input type="text" id="salt" name="salt" placeholder="Merchant Salt" value="r57Wom0mBH" /></span>
//                 </div>
    
//                 <div class="dv" >
//                     <span class="text12"><label>Transaction/Order ID:</label></span>
//                     <span><input type="text" id="txnid" name="txnid"  placeholder="Transaction ID" value={num} onLoad={handleClick} readonly=""  /></span>
//                 </div>
    
//                 <div class="dv">
//                     <span class="text12"><label>Amount:</label></span>
//                     <span><input type="text" id="name"  name="amount" placeholder="Amount" value={amount}  onChange={(e) => setamount(e.target.value)} /></span>    
//                     {/* <input type="text" id="name" name="name"
//                       value={amount}
//                       class="form-control" placeholder="Your Name"
//                       onChange={(e) => setamount(e.target.value)}
//                     ></input> */}
//                 </div>
    
//                 <div class="dv">
//                     <span class="text12"><label>Product Info:</label></span>
//                     <span>
//                 		<select name="pinfo" id="pinfo" class="select" required="">
//                 		    <option value="0">---Select Product Name---</option>
//                 			<option value='Annadana'>Annadana</option>
//                 			<option value='Education'>Education</option>
//                 			<option value='Medical Aid'>Medical Aid</option>
//                 			<option value='General Donation'>General Donation</option>
                			
//                 		</select>
//                 	</span>
//                 </div>
    
//                 <div class="dv">
//                     <span class="text12"><label>Name:</label></span>
//                     <span><input class="effect-9"  type="text" id="fname" name="fname" placeholder="First Name"  value={name}  onChange={(e) => setName(e.target.value)} /></span>
//                 </div>
    
//                 <div class="dv">
//                     <span class="text12"><label>Email ID:</label></span>
//                     <span><input type="email" id="email" name="email"  placeholder="Email ID" value={email}  onChange={(e) => setEmail(e.target.value)}  /></span>
//                 </div>
    
//                 <div class="dv">
//                     <span class="text12"><label>Mobile/Cell Number:</label></span>
//                     <span><input type="number" id="mobile"  name="mobile" placeholder="Mobile/Cell Number" value={mobile}  onChange={(e) => setMobile(e.target.value)} /></span>
//                 </div>
    
//                 <div class="dv" style={{display:"none"}}>
//                     <span class="text12"><label>Hash:</label></span>
//                     <span><input type="text" id="hash" name="hash" placeholder="Hash" value="" /></span>
//                 </div>
//                 {/* <div>
//                     <input class="btn center mt-3" type="submit" value="Pay" onclick= {validate}/>
//                 </div> */}
//                 <div class="text-center">
//                   {/* <button type="submit">Send Message</button>  */}
//                   <button type="submit" onClick={validate}> Submit </button>
//                   <button onClick={handleClick}>Generate random number</button>
//                   {/* <button onClick={refresh}>Refresh</button> */}
//                 </div>
//                 </form>
//    </div>
// </div>

// {/* <div class="main">
// 	<div>
//     	<img src="/assets/img/slide/PayU-logo.jpg" class="center mt-3"/>
//     </div>	
// 	<div class="container rec mt-1">
// 		<div class="row justify-content-md-center mt-1">
// 			<div class="col-md-8 mt-3">
// 			<img src="images/rb.png" class="ribin" alt=""/>
// 				<div class="row rec2 justify-content-md-center shadow p-4">	
// 					<div>
// 						<h2 class="center1">PAYU PAYMENT GATEWAY</h2>
// 					</div>
// 					<div class="col-md-4 head">Merchant Key:</div>
// 					<div class="col-md-6 detail"></div>
// 					<div class="col-md-4 head">Merchant Salt:</div>
// 					<div class="col-md-6  detail"></div>
// 					<div class="col-md-4 head">Transaction/Order ID:</div>
// 					<div class="col-md-6  detail"></div>
// 					<div class="col-md-4 head">Amount:</div>
// 					<div class="col-md-6  detail"></div>
// 					<div class="col-md-4 head">Product Info:</div>
// 					<div class="col-md-6  detail"></div>
// 					<div class="col-md-4 head">First Name:</div>
// 					<div class="col-md-6  detail"></div>
// 					<div class="col-md-4 head">Email ID:</div>
// 					<div class="col-md-6  detail"></div>
// 					<div class="col-md-4 head">Mihpayid:</div>
// 					<div class="col-md-6  detail"></div>
// 					<div class="col-md-4 head">Hash:</div>
					
// 				</div>
// 			</div>
// 		</div>
// 	</div>
// </div>

// <div class="main-2">
// 	<div>
//     	<img class="center mt-3" src="../images/index/leeway_logo.png" style="height: 57px;width: 111px;" />
//     </div>
//     <div>
//     	<h3 class="text-center mt-2">Leeway Softech Pvt Ltd</h3>
//     </div>	
// </div>
// <div class="container mt-5">
// 	<div class="row  bundle shadow mt-3">
// 		<div class="col-md-6 first mt-3">
// 			<form action="#" class="p-5 form-group" id="payment_form" name="payment_form">
//                 <input type="hidden" id="udf5" name="udf5"  />
//                 <input type="hidden" id="surl" name="surl"  />
//                 <div class="dv">
//                     <span class="text"><label>Merchant Key:</label></span>
//                     <span><input type="text" id="key" name="key" placeholder="Merchant Key"  /></span>
//                 </div>
    
//                 <div class="dv" >
//                     <span class="text"><label>Merchant Salt:</label></span>
//                     <span><input type="text" id="salt" name="salt" placeholder="Merchant Salt" /></span>
//                 </div>
    
//                 <div class="dv" >
//                     <span class="text"><label>Transaction/Order ID:</label></span>
//                     <span><input type="text" id="txnid" name="txnid"  placeholder="Transaction ID" value=" " readonly="" /></span>
//                 </div>
    
//                 <div class="dv">
//                     <span class="text"><label>Amount:</label></span>
//                     <span><input type="text" id="amount"  name="amount" placeholder="Amount" value="" /></span>    
//                 </div>
    
//                 <div class="dv">
//                     <span class="text"><label>Product Info:</label></span>
//                     <span>
//                 		<select name="pinfo" id="pinfo" class="select" required="">
//                 		    <option value="0">---Select Product Name---</option>
//                 			<option value='RCS'>RCS</option>
//                 			<option value='Whatsapp'>WHASTAPP</option>
//                 			<option value='Missedcall'>MISSCALL</option>
//                 			<option value='Bulksms'>BULK SMS</option>
//                 			<option value='Chatbot'>CHATBOT</option>
//                 		</select>
//                 	</span>
//                 </div>
    
//                 <div class="dv">
//                     <span class="text"><label>Name:</label></span>
//                     <span><input class="effect-9"  type="text" id="fname" name="fname" placeholder="First Name"  value="" /></span>
//                 </div>
    
//                 <div class="dv">
//                     <span class="text"><label>Email ID:</label></span>
//                     <span><input type="email" id="email" name="email"  placeholder="Email ID" value="" /></span>
//                 </div>
    
//                 <div class="dv">
//                     <span class="text"><label>Mobile/Cell Number:</label></span>
//                     <span><input type="number" id="mobile"  name="mobile" placeholder="Mobile/Cell Number" value="" /></span>
//                 </div>
    
//                 <div class="dv" >
//                     <span class="text"><label>Hash:</label></span>
//                     <span><input type="text" id="hash" name="hash" placeholder="Hash" value="" /></span>
//                 </div>
    
//                 <div>
//                     <input class="btn center mt-3" type="submit" value=" &#x20B9; Pay" onclick="return validation()" />
//                 </div>
// 	        </form>
// 	    </div>
// 		<div class="col-md-6 second mt-3">
// 			<img src="images/Credit.png"  width="400px" class="ico" alt=""/>
// 		</div>
// 	</div>
// </div> */}
// </section>
// </section>

// )

// }


// import React, { useState, useEffect } from 'react';
// import { Container, Row, Col, Form, FormLabel, FormControl, Button } from 'react-bootstrap';
// import axios from 'axios';
 


// export default function Donet() {
//     const [baseURL] = useState('http://sandboxsecure.payu.in/_payment');
//     const [title] = useState('Ract Js Redireact checkout');
//     const [key, setKey] = useState('p8SKrfEh');
//     const [salt] = useState('r57Wom0mBH');
//     const [txnid, setTxnid] = useState('txn' + Math.round(Math.random(1000, 5000) * 10000));
//     const [amount, setAmount] = useState('');
//     const [fname, setFname] = useState('');
//     const [email, setEmail] = useState('');
//     const [phone, setPhone] = useState('');
//     const [productinfo, setProductinfo] = useState('');
//     const [service_provider] = useState('payu_paisa');
//     const [hash, setHash] = useState('');
//     const [bolt,setBolt]=useState('');
//     const [formErrors, setFormErrors] = useState({});

//     return (
       
//         <>
//         <main id="main">
//           <section id="breadcrumbs" class="breadcrumbs1"></section>
//           <section id="contact" class="contact1">
//           <div class="text-center">
//             <h1>  शारदा पीठ द्वारका  </h1>
//             {/* <img src="assets/img/slide/PayU-logo.jpg" class="img-fluid img-fluid1"  alt="" style={{height:"57px;",width:"111px;"}} /> */}
//           </div>

// <div class="container mt-6">
// 	<div class="row  bundle shadow mt-3">
// 		<div class="col-md-6 first mt-3">
// 			<form action="http://localhost/maheshvari/payu.php" class="p-5 form-group" method="POST">
//              {/* id="payment_form" name="payment_form"> */}
//                 <input type="hidden" id="udf5" name="udf5" value="BOLT_KIT_PHP7" />
//                 <input type="hidden" id="surl" name="surl" value="http://localhost/maheshvari/response.php" />
//                 <input type="hidden" id="furl" name="furl" value="http://localhost/maheshvari/response.php" />
//                 <input type="hidden" name="service_provider" value={service_provider} />
//                 <div class="dv" style={{display:"none"}}> 
//                     <span class="text"><label>Merchant Key:</label></span>
//                     <span><input type="text" id="key" name="key" placeholder="Merchant Key" value="p8SKrfEh" /></span>
//                 </div>
    
               
    
//                 {/* <div class="dv" >
//                     <span class="text"><label>Transaction/Order ID:</label></span>
//                     <span><input type="text" id="txnid" name="txnid"  placeholder="Transaction ID" value={txnid} readOnly /></span>
//                 </div> */}
    
//                 <div class="dv">
//                     <span><label>Amount:</label></span>
//                     <input style={{marginLeft:"102px"}} type="number" id="amount"  name="amount" placeholder="Amount" value={amount} onChange={(e) => setAmount(e.target.value)} required />
//                     {/* <p style={{ color: "red" }}>{formErrors.amount}</p> */}
                        
                     
//                 </div>
    
//                 {/* <div class="dv">
//                     <span class="text"><label>Product Info:</label></span>
//                     <span>
                  
//                 		<select name="productinfo" id="productinfo" class="select" value={productinfo}  onChange={(e) => setProductinfo(e.target.value)} required  >
//                 		    <option value="0">---Select Product Name---</option>
//                 			<option value='dan'>dan</option>
//                 			<option value='Whatsapp'>WHASTAPP</option>
//                 			<option value='Missedcall'>MISSCALL</option>
//                 			<option value='Bulksms'>BULK SMS</option>
//                 			<option value='Chatbot'>CHATBOT</option>
//                 		</select>
//                 	</span>
//                 </div> */}
    
//                 <div class="dv">
//                     <span><label>Name:</label></span>
//                     <input style={{marginLeft:"120px"}} type="text" id="firstname" name="firstname" placeholder="First Name"  value={fname}  onChange={(e) => setFname(e.target.value)} required/>
//                 </div>
              
    
//                 <div class="dv">
//                     <span><label>Email ID:</label></span>
//                     <span><input style={{marginLeft:"102px"}} type="email" id="email" name="email"  placeholder="Email ID" value={email} onChange={(e) => setEmail(e.target.value)} required/></span>
//                 </div>
    
//                 <div class="dv">
//                     <span><label>Mobile/Cell Number:</label></span>
//                     <span><input style={{marginLeft:"12px"}} type="number" id="phone"  name="phone" placeholder="Mobile/Cell Number" value={phone} onChange={(e) => setPhone (e.target.value)} required /></span>
//                 </div>
    
//                 <div class="dv" style={{display:"none"}}>
//                      <span class="text"><label>Hash:</label></span>
//                     <span><input type="text" id="hash" name="hash" placeholder="Hash" value={hash} /></span>
//                 </div>
    
//                 <div>
//                     <input class="btn center mt-3" type="submit" value=" &#x20B9; pay"   />
//                 </div>
// 	        </form>
// 	    </div>
// 		<div class="col-md-6 second mt-3">
// 			<img src="images/Credit.png"  width="400px" class="ico" alt=""/>
// 		</div>
// 	</div>
// </div>
// </section>
// </main>
// </>
//     )
// }
